import { SpawnType } from "@1games-ru/region-shared/dist/enums/selectSpawn/type";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export interface SpawnState {
  spawnTypes: SpawnType[];
  activeSpawnType: SpawnType;
  hoverSpawnType: SpawnType;
}

const initialState: SpawnState = {
  spawnTypes: [],
  activeSpawnType: SpawnType.Undefined,
  hoverSpawnType: SpawnType.Undefined,
};

const spawnSlice = createSlice({
  name: "spawnSlice",
  initialState,
  reducers: {
    setSpawnTypes(state, action: PayloadAction<SpawnType[]>) {
      state.spawnTypes = action.payload.slice();
    },
    setActiveSpawnType(state, action: PayloadAction<SpawnType>) {
      state.activeSpawnType = action.payload;
    },
    setHoverSpawnType(state, action: PayloadAction<SpawnType>) {
      state.hoverSpawnType = action.payload;
    },
  },
});

export const spawnTypesSelector = (state: RootState) => state.spawn.spawnTypes;
export const activeSpawnTypeSelector = (state: RootState) => state.spawn.activeSpawnType;
export const hoverSpawnTypeSelector = (state: RootState) => state.spawn.hoverSpawnType;
export const hoverSpawnTypeIndexSelector = (state: RootState) =>
  state.spawn.spawnTypes.findIndex((spawnType) => state.spawn.hoverSpawnType === spawnType);

export const spawnReducer = spawnSlice.reducer;
export const { setSpawnTypes, setActiveSpawnType, setHoverSpawnType } = spawnSlice.actions;
